import { Children } from "react";

// Centered card grid: 1 → single, 2/4 → two columns (2+2), otherwise three columns; incomplete rows are centered.
const LAYOUT = {
  1: { wrap: "max-w-[560px]", item: "w-full" },
  2: { wrap: "max-w-[980px]", item: "w-full sm:w-[calc(50%-8px)] md:w-[calc(50%-10px)]" },
  3: { wrap: "", item: "w-full sm:w-[calc(50%-8px)] md:w-[calc(50%-10px)] lg:w-[calc((100%-40px)/3)]" },
};

export default function CardGrid({ children, className = "", testId, header = null }) {
  const items = Children.toArray(children).filter(Boolean);
  const n = items.length;
  const cols = n === 1 ? 1 : n === 2 || n === 4 ? 2 : 3;
  const { wrap, item } = LAYOUT[cols];
  return (
    <div className={`mx-auto ${wrap} ${className}`} data-testid={testId}>
      {header}
      <div className="flex flex-wrap justify-center gap-4 md:gap-5">
        {items.map((c, i) => (
          <div key={c.key ?? i} className={`flex ${item}`}>{c}</div>
        ))}
      </div>
    </div>
  );
}
